import { queryUuIdInfo, upLoadFile } from '@/api/common'

export default {
	data () {
		return {
			baseUrl: process.env.VUE_APP_BASE_API,
			form: {
				checked: false,
			},
			radio: null,
			excelList: [],

			excelUUid:'',

		};
	},
	computed: {
		lotteryName () {
			let lotteryArr = ['双色球', '大乐透', '福彩3D', '排列三']
			return lotteryArr[this.lotteryType - 1]
		}
	},
	methods: {
		async inputChange (e, type, item, loadingType) {

			console.log('type',type);

			item[loadingType] = true

			const currentLoadingType = loadingType; // 保存当前的 loadingType
			const currentItem = item; // 保存当前的 item

			if (type == 'excel_release_img' && !e.target.files[0].type.startsWith('image/')) {
				currentItem[currentLoadingType] = false
				return this.$message.error('图片类型不对')
			}

			const data = { file: e.target.files[0] };

			let uuid = await queryUuIdInfo()
			let params = this.$utils.getParamByJson({
				bizId: uuid,
				fileType: type,
				number: this.lotteryNo
			})

			if (type == 'excel_release_excel'){
				this.excelUUid = uuid
			}

			upLoadFile('?' + params, data).then((res) => {
				let { bizId, fileId, fileNames, fileType, urls } = res.data
				if (type == 'excel_release_img') {
					currentItem[type] = this.baseUrl + '/stage-api' + urls
				} else {
					let findIndex = urls.lastIndexOf('/');
					currentItem[type] = urls.substr(findIndex + 1)
				}
			}).finally(_ => {
				currentItem[currentLoadingType] = false
			});
		},

		// 确认发布按钮
		async confirmRelease () {

			// if (this.excelList.length === 0) {
			// 	return this.$message.error('请先选择需要发布的excel文件');
			// }

			// for (let i = 0; i < this.excelList.length; i++) {
			// 	let item = this.excelList[i];
			// 	console.log('item', JSON.parse(JSON.stringify(item)));
			// 	if ([2, 3].includes(item.mark)) {
			// 		if (!item.excel_release_excel || !item.excel_release_txt || !item.excel_release_img) {
			// 			this.$message.error(`请上传${item.name}的文件`);
			// 			return
			// 		}
			// 	} else {
			// 		if (!item.excel_release_excel || !item.excel_release_img) {
			// 			this.$message.error(`请上传${item.name}的文件`);
			// 			return
			// 		}
			// 	}
			// }

			let info = JSON.stringify(this.excelList)
				.replace(/excel_release_excel/g, 'excel')
				.replace(/excel_release_txt/g, 'txt')
				.replace(/excel_release_img/g, 'image')

			console.log('info', JSON.parse(info));

			// 预测类型 0：双色球； 1：大乐透； 2：3D； 3：排三
			let params = {
				preType: this.preType,
				title: `${this.vuex_userInfo.userName}${this.lotteryName}第（${this.lotteryNo}）期技巧师excel发布`,
				coin: this.select.value,
				remark: this.remark,
				info: JSON.parse(info),

				isFun: this.form.checked,

				number: this.lotteryNo,

				excleType: '2',  //excle类型 0：普通excle； 1：不容错excle 2:技巧师excle
				recordId: this.excelUUid || '',
			}

			this.$http.post('/stage-api/technician/release/excel', params).then(res => {
				console.log(res);
				if (res.code == 200) {
					this.$message.success('发布成功');
				} else {
					this.$message.error('发布失败');
				}

			})
		},

		// 添加|编辑 预测列表
		changeNum (row, currentIndex) {
			let index = this.navDb.arr[this.navDb.active].cont_active

			let tipStr = `<b style='color:green'>${row}</b>
			请输入或复制数字投注,每个号码之间用<b style='color:red'> 空格 </b>隔开
			例:01 02 03 04 05 06 07 08
			<span style='color:blue'>提示:按下回车键确认投注</span>`;

			this.$prompt(tipStr, '提示', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				dangerouslyUseHTMLString: true,
				maskClosable: false, // 禁止点击遮罩关闭
				inputValue: row ? row.input : '',
				inputValidator: (value) => {
					if (!value) { return '请输入或复制数字投注'; }

					const numberScope = extractNumbers(row.split('=')[0])

					let min = Math.min(...numberScope),
						max = Math.max(...numberScope);

					if (!isValidInput(value, min, max)) { return '输入格式不正确' }

					return true;

					function extractNumbers (str) {
						const numbers = str.match(/\d+/g);
						return numbers ? numbers.map(Number) : [];
					}

					function isValidInput (input, min, max) {
						try {
							let len = input.split(' ').length
							return len >= min && len <= max
						} catch (err) {
							return false
						}

					}


				}
			}).then(({ value }) => {
				console.log('valuexxxxxxxxxxxxxxxxx', value);
				console.log('row', row);
				if (row.name) {
					// 替换
					let idx = this.excelList.findIndex(item => item.name === row.name);
					if (idx !== -1) {
						this.excelList[idx].input = value;
					}
				} else {
					this.excelList.push({
						name: `[${this.navDb.arr[this.navDb.active].cont[index]}]`,
						publicationLimit: currentIndex,    //  选中的当前项的id
						input: value,
						expand: value,

						excel_release_excel: '',
						excel_release_img: '',
						excel_release_txt: '',

						excelLoading: false,
						txtLoading: false,
						imgLoading: false,

						publicationConditions: this.navDb.arr[this.navDb.active].value,  //条件:分析型条件红表|蓝表 ,排序型条件红表|蓝表
						direction: this.navDb.active,   //  nav1
						publicationType: index,   //  nav2 

						mark: JSON.parse(JSON.stringify(this.navDb.active))

					});
				}

				console.log('this.navDb.arr[this.navDb.active]', this.navDb.arr[this.navDb.active]);
				console.log('this.excelList', this.excelList);
			}).catch((err) => {
				console.log('取消', err);
			});
		},
		deleteItem (index) {
			confirm('确认删除吗？') && this.excelList.splice(index, 1);
		}
	},
}